/**
 * Stable workspace-tab resource keys for the Facility Model surface. The
 * generic mechanism (resourceKey dedup, destination keys, document keys)
 * lives in features/workspaceTabs; these builders are power-domain naming.
 */
export const subjectResourceKey = (subjectUid: string): string =>
  `subject:${subjectUid}`

export const sentinelResourceKey = (entryId: string): string =>
  `sentinel:${entryId}`

/** Ad-hoc trend identity: site + the sorted sensor set. */
export const trendResourceKey = (
  siteId: string,
  sensorIds: readonly string[]
): string => `trend:${siteId}:${[...sensorIds].sort().join(',')}`

/**
 * Saved-chart identity. Keyed by chart id alone so a second open focuses the
 * live editor instead of mounting a duplicate that would clobber its saves.
 */
export const chartResourceKey = (chartId: string): string => `chart:${chartId}`

/** One alert opened in Process Data: its window, signals, and marker. */
export const processDataAlertResourceKey = (
  siteId: string,
  alertId: string
): string => `pd-alert:${siteId}:${alertId}`
